"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var _index = _interopRequireDefault(require("@/components/fileImg/index.vue"));
var _banner = require("@/api/banner/banner");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      swiperInfo: {
        id: "",
        imageUrl: "",
        linkUrl: "",
        name: "",
        businessId: '',
        createBy: '',
        createTime: "",
        isDelete: '',
        remark: "",
        schoolId: '',
        sort: 0,
        updateBy: "",
        updateTime: ""
      },
      imageUrl: "",
      rules: {
        name: [{
          required: true,
          message: "请输入标题",
          trigger: "blur"
        }, {
          min: 1,
          max: 15,
          message: "标题长度推荐在 1 到 15 个字符",
          trigger: "blur"
        }]
      },
      info: {}
    };
  },
  created: function created() {},
  methods: {
    successUpLoad: function successUpLoad(e) {
      this.swiperInfo.imageUrl = e.ossOriUrl;
    },
    submit: function submit(v) {
      var _this = this;
      this.$refs[v].validate(function (valid) {
        if (valid) {
          if (_this.swiperInfo.imageUrl === "") {
            return _this.$message.error("请先上传轮播图片后,再进行提交。");
          } else {
            _this.info = JSON.parse(sessionStorage.getItem("info"));
            (0, _banner.savePageList)({
              imageUrl: _this.swiperInfo.imageUrl,
              linkUrl: _this.swiperInfo.linkUrl,
              name: _this.swiperInfo.name,
              businessId: _this.info.businessId,
              isDelete: 0,
              schoolId: _this.info.schoolId,
              sort: 0
            }).then(function () {
              _this.$message.success("操作成功。");
              _this.$router.push("/webSet/swiperSchool/index");
            });
          }
        }
      });
    },
    isBack: function isBack() {
      this.$router.push("/webSet/swiperSchool/index");
    }
  },
  components: {
    FileImg: _index.default
  }
};